/** Базовый URL auth/API. В dev по умолчанию '' → same-origin + setupProxy.js на прод. */
export function getAuthApiBase(): string {
  const raw = process.env.REACT_APP_AUTH_API_URL;
  if (raw !== undefined) {
    return raw.trim().replace(/\/$/, '');
  }
  if (process.env.NODE_ENV === 'development') {
    return '';
  }
  return 'https://api.datacircle.ru';
}

export const AUTH_API_BASE = getAuthApiBase();
